import React, { useEffect, useState, useContext } from "react";
import Card from "@mui/material/Card";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import CreateAccountingSessionReq from "../../../Classes/Models/Requests/AccountingSessions/CreateAccountingSessionReq";
import MDInput from "components/MDInput";
import AsyncSelect from "react-select/async";
import UsersApi from "../../../Classes/API/UsersApi";
import { LanguageContext } from "App";
import Swal from "sweetalert2";
import QuickDate from "./../../../components/QuickDate";
import searchUsersReq from "../../../Classes/Models/Requests/Users/SearchUser";
import UserTypes from "../../../Classes/Models/Requests/Users/UserTypes";
import SearchBalanceEntriesReq from "../../../Classes/Models/Requests/Accounting/SearchBalanceEntriesReq";
import MDButton from "components/MDButton";

const SearchBalancesBar = ({ setSearchRequest, GetUserBalanceEntries }) => {
  const [Id, setId] = useState();
  const { translations } = useContext(LanguageContext);
  const [FromTime, setFromTime] = useState(new Date());
  const [ToTime, setToTime] = useState(new Date());
  const [FromCurrentBalance, setFromCurrentBalance] = useState();
  const [ToCurrentBalance, setToCurrentBalance] = useState();
  const [FromBalanceVariation, setFromBalanceVariation] = useState();
  const [ToBalanceVariation, setToBalanceVariation] = useState();
  const [Description, setDescription] = useState();
  const [AccountingEntryId, setAccountingEntryId] = useState();
  const [AccountingSessionId, setAccountingSessionId] = useState();
  const [PackageIdSId, setPackageId] = useState();
  const [UsersSearch, setUsersSearch] = useState();
  const [User, setUser] = useState({});

  const [Optionid, setOptionId] = useState([]);

  useEffect(() => {
    GetUsers().then((res) => {
      setOptionId(res);
    });
  }, []);
  const GetUsers = async (input = "") => {
    let searchReq = new searchUsersReq();

    searchReq.name = input;
    let res = await UsersApi.SearchUsers(searchReq);

    if (res.status == "Success") {
      let optionsArr = res.data.list.map((item) => ({
        value: item,
        label: item.name,
      }));
      if (input) {
        optionsArr = optionsArr.filter((item) =>
          item.label.toLowerCase().includes(input.toLowerCase())
        );
      }
      return optionsArr;
    }
    return [];
  };

  const onSearch = async () => {
    let searchReq = new SearchBalanceEntriesReq();
    searchReq.id = Id;
    searchReq.fromTime = FromTime;
    searchReq.toTime = ToTime;
    searchReq.fromCurrentBalance = FromCurrentBalance;
    searchReq.toCurrentBalance = ToCurrentBalance;
    searchReq.fromBalanceVariation = FromBalanceVariation;
    searchReq.toBalanceVariation = ToBalanceVariation;
    searchReq.description = Description;
    searchReq.accountingEntryId = AccountingEntryId;
    searchReq.accountingSessionId = AccountingSessionId;
    searchReq.packageId = PackageIdSId;
    searchReq.userId = User.id;

    if (FromTime) {
      searchReq.fromTime = new Date(FromTime).toISOString();
    }
    if (ToTime) {
      searchReq.toTime = new Date(ToTime).toISOString();
    }

    setSearchRequest(searchReq);

    await GetUserBalanceEntries();
  };

  const onSearchNoDates = async () => {
    let searchReq = new SearchBalanceEntriesReq();
    searchReq.id = Id;
    searchReq.fromCurrentBalance = FromCurrentBalance;
    searchReq.toCurrentBalance = ToCurrentBalance;
    searchReq.fromBalanceVariation = FromBalanceVariation;
    searchReq.toBalanceVariation = ToBalanceVariation;
    searchReq.description = Description;
    searchReq.accountingEntryId = AccountingEntryId;
    searchReq.accountingSessionId = AccountingSessionId;
    searchReq.packageId = PackageIdSId;
    searchReq.userId = User.id;
    setSearchRequest(searchReq);
  };

  return (
    <Card mb={3} className=" mt-3 p-3" sx={{ marginBottom: "2em" }}>
      <MDBox pt={2} px={2} display="flex" justifyContent="space-between" alignItems="center">
        <MDTypography variant="h6" fontWeight="medium">
          {translations.usrBalanceEnteriesSearch}
        </MDTypography>
        <div>
          <MDButton
            type="button"
            sx={{
              backgroundColor: "#3560AD",
              "&:hover": { backgroundColor: "#4682B4" },
              marginRight: "7px",
            }}
            color="text"
            onClick={() => onSearch()}
          >
            {translations.usrBalanceEnteriesSearch}
          </MDButton>
          <MDButton
            type="button"
            sx={{ backgroundColor: "#3560AD", "&:hover": { backgroundColor: "#4682B4" } }}
            color="text"
            onClick={() => onSearchNoDates()}
          >
            {translations.usrBalanceEnteriesSearchNoDates}
          </MDButton>
        </div>
      </MDBox>
      <div className={translations.setlang === "ar" ? "rtl-label" : ""}>
        <div className="container-fluid">
          <div className="row">
            <div className="col-md-4 mt-3">
              <MDInput
                className="full-width"
                onChange={(e) => setId(e.target.value)}
                label={translations.sessionWithoutEnteriesid}
                fullWidth
              ></MDInput>
            </div>
            <div className="col-md-4 mt-3">
              <MDInput
                className="full-width"
                type="number"
                onChange={(e) => setAccountingEntryId(e.target.value)}
                label={translations.usrBalanceEnterieAccountingEntryId}
                fullWidth
              ></MDInput>
            </div>

            <div className="col-md-4 mt-3">
              <MDInput
                className="full-width"
                type="number"
                onChange={(e) => setFromCurrentBalance(e.target.value)}
                label={translations.usrBalanceEnterieFromCurrentBalance}
                fullWidth
              ></MDInput>
            </div>
            <div className="col-md-4 mt-3">
              <MDInput
                className="full-width"
                type="number"
                onChange={(e) => setToCurrentBalance(e.target.value)}
                label={translations.usrBalanceEnterieToCurrentBalance}
                fullWidth
              ></MDInput>
            </div>
            <div className="col-md-4 mt-3">
              <MDInput
                className="full-width"
                type="number"
                onChange={(e) => setFromBalanceVariation(e.target.value)}
                label={translations.usrBalanceEnterieFromBalanceVariation}
                fullWidth
              ></MDInput>
            </div>
            <div className="col-md-4 mt-3">
              <MDInput
                className="full-width"
                type="number"
                onChange={(e) => setToBalanceVariation(e.target.value)}
                label={translations.usrBalanceEnterieToBalanceVariation}
                fullWidth
              ></MDInput>
            </div>
            <div className="col-md-4 mt-3">
              <MDInput
                className="full-width"
                type="text"
                onChange={(e) => setDescription(e.target.value)}
                label={translations.usrBalanceEnterieDescription}
                fullWidth
              ></MDInput>
            </div>
            <div className="col-md-4 mt-3">
              <MDInput
                className="full-width"
                type="number"
                onChange={(e) => setAccountingSessionId(e.target.value)}
                label={translations.usrBalanceEnterieAccountingSessionId}
                fullWidth
              ></MDInput>
            </div>
            <div className="col-md-4 mt-3">
              <MDInput
                className="full-width"
                type="number"
                onChange={(e) => setPackageId(e.target.value)}
                label={translations.usrBalanceEnteriePackageId}
                fullWidth
              ></MDInput>
            </div>

            <div className="col-md-4 mt-3">
              <MDTypography variant="button" fontWeight="regular" color="text">
                <AsyncSelect
                  isClearable={true}
                  placeholder={translations.usrBalanceEnterieSelectUser}
                  defaultOptions={Optionid}
                  loadOptions={(inputValue) => GetUsers(inputValue)}
                  onChange={(e) => setUser(e ? e.value : "")}
                  // value={TypeId}
                  fullWidth
                />
              </MDTypography>
            </div>

            <div className="col-md-4 mt-3">
              <MDInput
                className="full-width"
                type={"number"}
                onChange={(e) => setSessionId(e.target.value)}
                label={translations.usrBalanceEnterieSessionId}
                fullWidth
              ></MDInput>
            </div>
            <div className="col-md-4 mt-3"></div>

            <div className="qd col-md-5">
              <div className="quick_date_container">
                <p>{translations.PatientStayQuickDate}</p>
                <QuickDate
                  setFrom={setFromTime}
                  setTo={setToTime}
                  placeholder={"Quick Last Updated"}
                />
              </div>
            </div>
            <div className="qd col-md-6">
              <label>{translations.PatientStayStartDateFrom}:</label>
              <div
                className="quick_date"
                style={{
                  display: "grid",
                  gridTemplateColumns: "auto auto auto", // 3 columns for the input, p, and second input
                  gap: "10px", // optional, for spacing between the columns
                  alignItems: "center", // vertically center the items
                }}
              >
                <input
                  type="date"
                  style={{
                    width: "auto",
                    ...(window.innerWidth <= 768 && { width: "100%" }),
                  }}
                  onChange={(e) => {
                    setFromTime(e.target.value);
                  }}
                  value={FromTime}
                />

                <p>{translations.PatientStayTo}</p>

                <input
                  type="date"
                  style={{
                    width: "auto",
                    ...(window.innerWidth <= 768 && { width: "100%" }),
                  }}
                  onChange={(e) => {
                    setToTime(e.target.value);
                  }}
                  value={ToTime}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </Card>
  );
};

export default SearchBalancesBar;
